// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#catalogLibrary .tile {
  margin-bottom: 1.75em;
}

#catalogLibrary .tile .tile-inner {
  margin-left: 2em;
  margin-right: 2em;
  border: 2px solid #ccc;
  min-height: 32.5em;
  padding: 1.75em;
}

#catalogLibrary .tile .margin-bottom {
  margin-bottom: 0.75em;
}

#catalogLibrary .tile .description {
  min-height: 10em;
  font-size: 1em;
  text-align: left;
}

#catalogLibrary .view-all {
  color: #1eabe3;
  font-size: 1.25em;
}

#catalogLibrary #categoriesContainer {
  padding: 0px;
}

#catalogLibrary .name {
  font-size: 2em;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}

#catalogLibrary .align-bottom {
  position: absolute;
  bottom: 0;
  right: 2em;
}

#catalogLibrary .panel-title {
  height: 8em;
}

#catalogLibrary .top-description {
  margin: 20px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/catalog/catalogLibrary.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd","sourcesContent":["#catalogLibrary .tile {\n  margin-bottom: 1.75em;\n}\n\n#catalogLibrary .tile .tile-inner {\n  margin-left: 2em;\n  margin-right: 2em;\n  border: 2px solid #ccc;\n  min-height: 32.5em;\n  padding: 1.75em;\n}\n\n#catalogLibrary .tile .margin-bottom {\n  margin-bottom: 0.75em;\n}\n\n#catalogLibrary .tile .description {\n  min-height: 10em;\n  font-size: 1em;\n  text-align: left;\n}\n\n#catalogLibrary .view-all {\n  color: #1eabe3;\n  font-size: 1.25em;\n}\n\n#catalogLibrary #categoriesContainer {\n  padding: 0px;\n}\n\n#catalogLibrary .name {\n  font-size: 2em;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n}\n\n#catalogLibrary .align-bottom {\n  position: absolute;\n  bottom: 0;\n  right: 2em;\n}\n\n#catalogLibrary .panel-title {\n  height: 8em;\n}\n\n#catalogLibrary .top-description {\n  margin: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
